import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const AddIcone = (props) => {
  return (
    <svg viewBox="-3 0 21 21" width="21" height="21" className="icon">
      <g>
        <path
          vectorEffect="non-scaling-stroke"
          d="M13.5 2H.5c-.3 0-.5.2-.5.5s.2.5.5.5h.9l.7 11.3c.1 1 .8 1.7 1.7 1.7h6.3c.9 0 1.6-.7 1.7-1.7L12.6 3h.9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM5 14c-.3 0-.5-.2-.5-.5l-.5-9c0-.2.2-.5.5-.5s.5.2.5.5l.5 9c0 .2-.2.5-.5.5zm2.5-.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5s.5.2.5.5v9zm2 0c0 .3-.2.5-.5.5s-.5-.3-.5-.5l.5-9c0-.3.3-.5.5-.5.3 0 .5.3.5.5l-.5 9z"
          fill={props.color}
        />
      </g>
    </svg>
  );
};

export default AddIcone;
